import type React from "react";
import {Outlet} from "react-router";
import {Box} from "@mui/system";
import {SimpleEnvWrapper} from "~/jobs/wrapper/SimpleEnvWrapper";
import {DRAWER_HEADER_HEIGHT_LG} from "~/components/main/drawer/DrawerConstants.ts";

/** Databag-loading wrapper for the whole Taxonomy Builder v2 module. */
export const TaxonomyBuilderLayout: React.FC = () => (
    <SimpleEnvWrapper state={{fluid: true, appSection: 'cleanup'}}>
        <Box sx={{height: `calc(100vh - ${DRAWER_HEADER_HEIGHT_LG}px)`, overflow: 'auto', position: 'relative'}}>
            <Outlet/>
        </Box>
    </SimpleEnvWrapper>
);
